module.exports = __webpack_public_path__ + "static/media/placeholder.f482c158.png";